import { JsonValue } from './jsonDiff';

/**
 * Pull display text out of a survey node field that may be a plain string or
 * a localized Text object ({ en: ..., es: ..., ... }). Empty strings are
 * treated as absent so the caller can fall through to the next field.
 */
function displayText(v: JsonValue | undefined): string | undefined {
  if (typeof v === 'string') return v || undefined;
  if (typeof v === 'object' && v !== null && !Array.isArray(v) && typeof v.en === 'string') {
    return v.en || undefined;
  }
  return undefined;
}

/**
 * Label survey definition nodes the way reviewers see them: the node's kind
 * plus its English name/title (falling back to its target path), e.g.
 * "Section: Income" or "Subsurvey: intake".
 *
 * Pass as the `labelForNode` option of diffJson/diffJsonReport so survey
 * diffs carry human-readable breadcrumbs alongside structural paths.
 */
export function surveyNodeLabel(node: JsonValue): string | undefined {
  if (typeof node !== 'object' || node === null || Array.isArray(node)) return undefined;
  if (typeof node.kind !== 'string') return undefined;
  const text = displayText(node.name) ?? displayText(node.title) ?? displayText(node.path) ?? '';
  return `${node.kind}: ${text}`;
}
